module.exports = __webpack_public_path__ + "static/media/LEE_KAI.c7c28b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/LEE_KAI.jpg
// module id = 1118
// module chunks = 0